module.exports = __webpack_public_path__ + "/static/assets/ce48bbdede9c57e87630b15c9b33dd5b.png";